export default "__VITE_PUBLIC_ASSET__9519a09b__"